import React from "react";
import "./Testimonials.css";

const courseReviews = [
  {
    name: "Aman Khanna",
    course: "Frontend with React",
    review:
      "The React course was spot on—JSX, hooks, and APIs were taught with real-world examples. I ended up building 3 deployable projects that impressed recruiters.",
  },
  {
    name: "Karthik Iyer",
    course: "AI & ML",
    review:
      "This course helped me understand ML from the ground up. I built a chatbot using Python and TensorFlow that I showcased during interviews—it made a real difference.",
  },
  {
    name: "Sneha Desai",
    course: "Python Programming",
    review:
      "Coming from a non-tech background, I found the Python course extremely beginner-friendly. I can now confidently write automation scripts and work with data.",
  },
  {
    name: "Rahul Mehra",
    course: "Java Programming",
    review:
      "The Java curriculum is thorough and covers OOPs, collections, and backend integration. It helped me crack my technical interview at a mid-size tech company.",
  },
];


const CourseReviewTestimonials = () => {
  return (
    <div className="testimonial-section">
      <h2 className="testimonial-heading">Learner Reviews</h2>
      <div className="testimonial-slider">
        <div className="testimonial-track">
          <div className="testimonial-track">
            {[...courseReviews, ...courseReviews].map((item, index) => (
              <div className="testimonial-card" key={index}>
                <h3>{item.name}</h3>
                <p className="testimonial-course">{item.course || item.role}</p>
                <p className="testimonial-content">"{item.review || item.story}"</p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
};

export default CourseReviewTestimonials;
